import { useDispatch, useSelector } from "react-redux";
import { Button } from "semantic-ui-react";
import { useToasts } from "react-toast-notifications";
import { editModeOn, selectEditMode } from "../../slices/editMode/editModeSlice";
import { selectGlobalLoading } from "../../slices/globalLoading/globalLoadingSlice";
import { selectChangedResourcesList, selectChangedResourcesListStatus } from "../../slices/changedResourcesList/changedResourcesListSlice";
import { selectTabFocus } from "../../slices/tabPane/tabPaneSlice";
import { selectCurrentUserApiToken, selectCurrentUserId, selectSseConnectionId} from "../../slices/currentUser/currentUserSlice";
import { selectAllResources, selectResourceById } from "../../slices/resourceCollection/resourceCollectionSlice";
import submitUpdatedResource from "../resourceDisplayCommonFunctions/submitUpdatedResource";

const EditUpdateButton = ({ foi, jsonViewEditingState, setJsonViewEditingState, setParentResourceAlertModalState }) => {
    const { addToast } = useToasts();
    const dispatch = useDispatch();
    const editMode = useSelector(state => selectEditMode(state));
    const connectionId = useSelector(selectSseConnectionId);
    const resourceCollection = useSelector(state => selectAllResources(state));
    const unsavedChanges = useSelector(state => selectChangedResourcesListStatus(state));
    const changedResourcesList = useSelector(state => selectChangedResourcesList(state));
    const parentResourceDetail = useSelector(state => selectResourceById(state, foi));
    const resourceJson = parentResourceDetail?.revisedResourceJson || parentResourceDetail?.resourceJson;
    const siteIsLoading = useSelector(selectGlobalLoading);
    const userId = useSelector(selectCurrentUserId);
    const editPermission = parentResourceDetail?.usageData?.editpermission;
    const apiToken = useSelector(selectCurrentUserApiToken);
    const tabFocus = useSelector(state => selectTabFocus(state));
    const editText = "Edit " + (resourceJson?.resourceType || "");

    return <Button className="formButton navigationButton"
        style={{ color: unsavedChanges !== "hasChanges" && "#000000",
            width: "100%",
            margin: "0px"
        }}
        positive={unsavedChanges === "hasChanges"}
        content={(editMode || unsavedChanges === "hasChanges") ? "Save All Changes" : editText}
        onClick={() => {
            if (editMode || unsavedChanges === "hasChanges") {
                submitUpdatedResource(foi, parentResourceDetail, apiToken, connectionId, dispatch, resourceCollection,
                    changedResourcesList, tabFocus, jsonViewEditingState, setJsonViewEditingState, setParentResourceAlertModalState, addToast);
            } else {
                dispatch(editModeOn());
            }
        }}
        disabled={(!siteIsLoading && userId && editPermission) ? false : true}
    />;
};

export default EditUpdateButton;